import { createContext, useContext, useEffect, useState } from "react";
import { API, API_URL } from "@/lib/api";

const StudioCtx = createContext({ settings: null, refresh: async () => {} });

function hexToHsl(hex) {
  const r = parseInt(hex.slice(1, 3), 16) / 255, g = parseInt(hex.slice(3, 5), 16) / 255, b = parseInt(hex.slice(5, 7), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b); let h = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) { const d = max - min; s = l > .5 ? d / (2 - max - min) : d / (max + min); if (max === r) h = (g - b) / d + (g < b ? 6 : 0); else if (max === g) h = (b - r) / d + 2; else h = (r - g) / d + 4; h /= 6; }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function StudioProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const refresh = async () => {
    const { data } = await API.get("/studio/public");
    const backendOrigin = API_URL.replace(/\/api$/, "");
    const logoUrl = data.logo_url ? `${backendOrigin}${data.logo_url}?v=${Date.now()}` : `${backendOrigin}/api/studio/logo`;
    setSettings({ ...data, logo_url: logoUrl });
    document.title = "Studio CLG";
    let favicon = document.querySelector("link#studio-favicon");
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.id = "studio-favicon";
      favicon.rel = "icon";
      document.head.appendChild(favicon);
    }
    favicon.href = logoUrl;
    const appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (appleIcon) appleIcon.href = logoUrl;
    if (data.primary_color) document.documentElement.style.setProperty("--primary", hexToHsl(data.primary_color));
    if (data.accent_color) document.documentElement.style.setProperty("--accent", hexToHsl(data.accent_color));
    if (data.sidebar_color) document.documentElement.style.setProperty("--sidebar-color", data.sidebar_color);
    if (data.sidebar_text_color) document.documentElement.style.setProperty("--sidebar-text-color", data.sidebar_text_color);
  };
  useEffect(() => { refresh().catch(() => {}); }, []);
  return <StudioCtx.Provider value={{ settings, refresh }}>{children}</StudioCtx.Provider>;
}

export const useStudio = () => useContext(StudioCtx);
